import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {TableColumn, SortDirection, FieldType} from './table-column';
import {Icon} from '../icon/icon';

require('../../../../icons/caretdown.svg');
require('../../../../icons/caretup.svg');

@Component({
  template: require('./table-header.html'),
  name: 'wc-table-header',
  components: {
    'wc-icon': Icon
  }
})
export class TableHeader extends Vue {
  @Prop()
  data: Array<any>;
  @Prop()
  columns: Array<TableColumn>;
  @Prop()
  rowSelection: boolean;
  @Prop()
  expandableRow: boolean;

  selected: boolean = false;
  fieldType = FieldType;

  @Watch('data')
  dataChange() {
    if (this.data.some((item) => !item.wcSelected)) this.selected = false;
    else this.selected = true;
  }

  sort(column: TableColumn, direction: SortDirection, index: any) {
    if (!column.sortable) return;
    
    for(let tableColumn of this.columns) {
      if (tableColumn.sortable && tableColumn.field !== column.field) tableColumn.sortDirection = undefined;
    }

    if (direction === -1) {
      direction = column.sortDirection === 0 ? 1 : 0;
    }
    
    column.sortDirection = direction;
    this.columns.splice(index, 1, column);
    this.$emit('sortClick', column, direction);
  }

  selectAllChange() {
    this.$emit('selectAll', this.selected);
  }
}



// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/table/table-header.ts